<template>
  <div class="contract-register-filter">
    <div class="contract-register-text-filter" style="margin-bottom: 8px;">
      <text-filter
        type="contractsRegister"
        field="text_filter"
        label="Поиск по названию, шифру или номеру договора"
      />
    </div>
    <div class="filters-container">
      <select-filter
        type="contractsRegister"
        field="customer"
        label="Заказчик"
        request="page/other_company"
        :parse-value="({ name }) => name"
        :filterable="true"
      />
      <select-filter
        type="contractsRegister"
        field="status"
        label="Статус"
        request="objectInfo/contract_statuses"
        :parse-value="({ name }) => name"
      />
      <sorting-control
        style="margin-left: 32px;"
        type="contractsRegister"
        :values="sortingFields"
      />
    </div>
  </div>
</template>

<script>
import TextFilter from './helpers/text-filter'
import SelectFilter from './helpers/select-filter'
import SortingControl from './helpers/sorting-control'
import { getFullName } from '@/utils'

const sortingFields = [
  { field: 'code', name: 'Шифр' },
  { field: 'date', name: 'Дата начала' }
]

export default {
  components: {
    TextFilter,
    SelectFilter,
    SortingControl
  },
  data () {
    return {
      sortingFields,
      getFullName
    }
  }
}
</script>

<style></style>
